import { render, staticRenderFns } from "./saveNews.vue?vue&type=template&id=df2a7364&"
import script from "./saveNews.vue?vue&type=script&lang=js&"
export * from "./saveNews.vue?vue&type=script&lang=js&"
import style0 from "./saveNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports